import { Rate } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';
import { Typography } from '../../DesignSystemV2/Typography';

const Layout = styled.div<{ percentage: number }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  gap: 8px;

  .ant-rate {
    color: ${colorsV2.yellow100};
    line-height: 20px;
    display: flex;
    align-items: center;
    .ant-rate-star-second {
      line-height: 0;
    }
  }

  .ant-rate-star {
    &:not(:last-child) {
      margin-right: 4px;
    }
  }

  .ant-rate-star-first {
    width: ${(props) => props.percentage}%;
  }
`;

export const Rating = ({ rating = 5, review = '' }) => {
  const percentage = (rating % 1) * 100;

  return (
    <Layout percentage={percentage}>
      <Rate
        disabled
        allowHalf
        defaultValue={rating}
        character={
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.3887 6.89552L13.4298 6.17481L11.213 1.68067C11.1524 1.55762 11.0528 1.45802 10.9298 1.39747C10.6212 1.24512 10.2462 1.37208 10.0919 1.68067L7.87507 6.17481L2.91608 6.89552C2.77936 6.91505 2.65436 6.9795 2.55866 7.07716C2.44296 7.19607 2.37921 7.35606 2.3814 7.52196C2.3836 7.68787 2.45157 7.84611 2.57038 7.96192L6.15827 11.46L5.31061 16.3994C5.29074 16.5143 5.30345 16.6325 5.34732 16.7405C5.39118 16.8486 5.46444 16.9422 5.55879 17.0107C5.65314 17.0792 5.76481 17.1199 5.88112 17.1282C5.99743 17.1365 6.11375 17.1121 6.21686 17.0576L10.6524 14.7256L15.088 17.0576C15.2091 17.1221 15.3497 17.1436 15.4844 17.1201C15.8243 17.0615 16.0528 16.7393 15.9942 16.3994L15.1466 11.46L18.7344 7.96192C18.8321 7.86622 18.8966 7.74122 18.9161 7.6045C18.9688 7.2627 18.7305 6.9463 18.3887 6.89552Z"
              // fill={colorsV2.yellow100}
              fill="currentColor"
            />
          </svg>
        }
      />

      <Typography.Paragraph color="black80" variant="regular/12">
        {review || '(224 Reviews)'}
      </Typography.Paragraph>
    </Layout>
  );
};
